import createReducer from 'common/redux/utils/createReducer';
import { List, Map } from 'immutable';
import keyBy from 'lodash.keyby';
import { RECEIVE_FUNNEL } from 'funnel/actions/funnel';
import {
  CREATE_EXCLUSION,
  REMOVE_EXCLUSION,
  UPDATE_EXCLUSION,
} from 'funnel/actions/exclusion';

const getInitialState = {
  items: List(),
};

const exclusions = createReducer(getInitialState, {
  [RECEIVE_FUNNEL](state, { funnel }) {
    const { exclusion_grid: grid } = funnel;

    // Creapy but we can't group by tuple in JS
    const items = List(grid)
      .groupBy(e => `${e.product}_${e.order}`)
      .map((exclusions, key) => {
        const product = Number(key.substring(0, key.indexOf('_')));
        const order = Number(key.substring(key.indexOf('_') + 1, key.length));

        const answers = Map(keyBy(exclusions.toArray(), 'answer')).map(
          v => true
        );

        return {
          product,
          order,
          answers,
        };
      })
      .toList();

    return {
      ...state,
      items,
    };
  },
  [CREATE_EXCLUSION](state, { product }) {
    const exclusion = {
      product,
      order: state.items.filter(e => e.product === product).size + 1,
      answers: Map(),
    };

    return {
      ...state,
      items: state.items.push(exclusion),
    };
  },
  [REMOVE_EXCLUSION](state, { product, exclusion }) {
    return {
      ...state,
      items: state.items.filterNot(
        i => i.product === product && i.order === exclusion
      ),
    };
  },
  [UPDATE_EXCLUSION](state, { product, answer, order }) {
    const items = state.items.map(i => {
      if (i.product === product && i.order === order) {
        const updatedAnswers = i.answers.update(answer.id.toString(), a => !a);

        return {
          ...i,
          answers: updatedAnswers,
        };
      }

      return i;
    });

    return {
      ...state,
      items,
    };
  },
});

export default exclusions;



// WEBPACK FOOTER //
// ./src/modules/funnel/reducers/exclusions.js